var DONE = 4; // readyState 4 means the request is done.
var OK = 200; // status 200 is a successful return.

const MakeAjaxCall = function (url, requestObj, callback = false) {

   var xhr = new XMLHttpRequest();
   xhr.open('POST', `${SITE_ROOT}/AJAX/${url}.php`);
   xhr.responseType = 'json';
   xhr.send(JSON.stringify(requestObj));
   xhr.onreadystatechange = function (e) {
      if (xhr.readyState === DONE) {
         if (xhr.status === OK) {
            let response = (e.target.responseType === 'json') ? xhr.response : JSON.parse(xhr.responseText);
            if (response.status === -1) { // User credential problems - log them out
               window.location = "/LOGOUT.php?status=" + response.errorCode;
            } else {
               if (callback) callback(response);
               if (typeof response.status !== 'undefined')
                  if (response.status === 999)
                     infoMessage({message: "A problem occurred - please try again", type: "error"});
            }
         } else {
            if ((xhr.status === 404 || xhr.status === 500)) {
               infoMessage({message: "Server communication error", type: "error"});
               if (callback) callback({status: 999});
            }
         }
      }
   };
};

const SendAjaxFile = function (url, requestObj, callback = false) {
   let fileInput = document.getElementById(requestObj.fileID);
   let file = fileInput.files[0];
   let formData = new FormData();
   formData.append('file', file);
   for (var key in requestObj)
      formData.append(key, requestObj[key]);
   let xhr = new XMLHttpRequest();
   xhr.open('POST', `${SITE_ROOT}/AJAX/${url}.php`);
   xhr.responseType = 'json';
   xhr.send(formData);
   xhr.onreadystatechange = function (e) {
      if (xhr.readyState === DONE) {
         if (xhr.status === OK) {
            let response = (e.target.responseType === 'json') ? xhr.response : JSON.parse(xhr.responseText);
            if (xhr.response.status === -1) { // Problem accessing the user's session - log them out now
               window.location = "/LOGOUT.php?status=" + xhr.response.errorCode;
            } else {
               if (callback) callback(response);
               if (typeof response.status !== 'undefined')
                  if (response.status === 999)
                     infoMessage({message: "A problem occurred - please try again", type: "error"});
            }
         } else {
            if ((xhr.status === 404 || xhr.status === 500)) {
               infoMessage({message: "Server communication error", type: "error"});
            }
         }
      }
   };
};
